<template>
  <div v-if="columns.length > 1">
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Columns Gap</span>
      <div class="wf-w-1/2">
        <VueSlider
          ref="top-slider"
          v-model="gap"
          :interval="1"
          adsorb
          tooltip="none"
          :duration="0"
          :data="gapClasses"
        ></VueSlider>
      </div>
    </li>
  </div>
</template>

<script>
  import {ColumnGapClasses} from '../classes/ColumnGapClasses'
  import {RowColumnGapContainerClasses} from '../classes/RowColumnGapContainerClasses'
  import MenuStyleProperty from '../contracts/MenuStyleProperty'
  export default MenuStyleProperty.extend({
    data() {
      return {
        gap: 'GAP_NONE'
      }
    },

    watch: {
      gap() {
        this.updateGap()
      }
    },
    computed: {
      columns() {
        let elementModule = 'columnModule'
        if (Object.prototype.hasOwnProperty.call(this.element, 'componentRow')) {
          elementModule = 'componentColumnModule'
        }
        if (this.module == 'layoutRowModule') {
          elementModule = 'layoutColumnModule'
        }
        return this.$store.getters[`${elementModule}/elements`](this.element, this.parentModule)
      },
      gapClasses() {
        return Object.keys(ColumnGapClasses)
      },
      rowMarginClasses() {
        return Object.keys(RowColumnGapContainerClasses)
      },
      rowColumnsGapContainer() {
        let rowContainerClasses = {
          GAP_NONE: 'GAP_CONTAINER_NONE',
          GAP_SM: 'GAP_CONTAINER_SM',
          GAP_LG: 'GAP_CONTAINER_LG',
          GAP_XL: 'GAP_CONTAIER_XL',
        }
        return rowContainerClasses[this.gap]
      }
    },
    methods: {
      updateGap() {
        let elementModule = 'columnModule'
        if (Object.prototype.hasOwnProperty.call(this.element, 'componentRow')) {
          elementModule = 'componentColumnModule'
        }
        if (this.module == 'layoutRowModule') {
          elementModule = 'layoutColumnModule'
        }
        this.columns.forEach((column, index) => {
          let overrideElement = new Object
          let columnType = 'column'
          if (Object.prototype.hasOwnProperty.call(this.element, 'componentRow')) {
            columnType = 'componentColumn'
          } 
          this.$set(overrideElement, columnType, index)
          return this.addToArray(
            elementModule,
            [{property: 'ColumnGap', value: this.gap, touched: false}],
            'containerClasses',
            this.device,
            overrideElement,
            true,
            this.parentModule
          )
        })
        if (elementModule == 'columnModule') {
          this.addToArray(
            this.module,
            [{property: 'RowColumnGapContainer', value: this.rowColumnsGapContainer, touched: false}],
            'classes',
            this.device,
            true,
            this.parentModule
          )
        }
      }
    }
  })
</script>